import React, {FunctionComponent, useEffect} from 'react'
import styles from './StatisticsFilters.module.sass'
import {Checkbox} from '../../../controls/Checkbox/Checkbox'
import {Colors} from '../../../../styles'
import FiltersClearIcon from '../../../../../files/filters-clear.svg'
import Button from '../../../controls/Button/Button'
import Splitter from '../../../etc/Splitter/Splitter'
import {useRootDispatch, useRootSelector} from '../../../../utils/hooks'
import DateRangeInput from '../../../data-components/date/DateRangeInput/DateRangeInput'
import {flow} from 'fp-ts/function'
import {isDefinedTuple, toBool} from '../../../../utils/utils'
import TwoLevelDropdown from '../../../data-components/dropdowns/TwoLevelDropdown/TwoLevelDropdown'
import {getId} from '../../../../utils/entity-utils'
import {toServerDate} from '../../../../utils/date-utils'
import {Brand, ClientWithBrands} from '../../../../responses/refs/refs'
import {apiRequests} from '../../../../http/config'
import {byClientActions} from '../../../../redux/pages/statistics/byClient'
import Spacer from '../../../etc/Spacer'
import {byWorkActions} from '../../../../redux/pages/statistics/byWork'
import StatisticsInWork from './StatisticsInWork'
import {isSome} from 'fp-ts/Option'

const StatisticsFilters: FunctionComponent = () => {
    const dispatch = useRootDispatch()
    const {date, periods, clients, brands} = useRootSelector(state => state.pages.statistics.byClient)
    useEffect(() => {
        if (isDefinedTuple(date)) {
            dispatch(byClientActions.data.request({
                date_from: toServerDate(date[0]),
                date_to: toServerDate(date[1]),
                compare: toBool(periods),
                brands: brands.map(getId),
                clients: clients.map(getId),
            }))
        }
    }, [dispatch, date, brands, clients, periods])

    const {data} = useRootSelector(state => state.pages.statistics.byWork)

    useEffect(() => {
        dispatch(byWorkActions.data.request())
    }, [dispatch])

    return <div className={styles.filters}>
        <Button
            title={'Очистить фильтры'}
            onClick={() => dispatch(byClientActions.clearFilters())}
        >
            <FiltersClearIcon/>
        </Button>
        <DateRangeInput navigation value={date} onChange={flow(byClientActions.setDate, dispatch)}/>
        <Checkbox
            color={Colors.darkGrey}
            value={periods}
            onChange={flow(byClientActions.setPeriods, dispatch)}
        >
            Сравнить периоды
        </Checkbox>
        <TwoLevelDropdown<ClientWithBrands, Brand>
            className={styles.dropdown}
            placeholder={'Клиент/Бренд'}
            selection={clients}
            subselection={brands}
            render={client => client.short_title}
            subRender={brand => brand.title}
            selector={client => client.brands}
            request={query => apiRequests.dictionary.list({
                query,
                params: {key: 'client'}
            })}
            onSelectionChange={flow(byClientActions.setClients, dispatch)}
            onSubselectionChange={flow(byClientActions.setBrands, dispatch)}
        />
        <Splitter/>
        <Spacer/>
        {
            isSome(data) && <StatisticsInWork data={data.value}/>
        }

    </div>
}

export default StatisticsFilters